import type { ProductsQuery } from "@modules/products/queries/ProductsQuery";
import type SdkMethodsCollector from "@modules/sdk/methods/SdkMethodsCollector";
import type Sdk from "@modules/sdk/Sdk";
import type { SdkRegisteredModuleInterface } from "@modules/sdk/SdkRegisteredModuleInterface";

import RewardsSdkEvents from "./RewardsSdkEvents";
import RewardsSdkMethods from "./RewardsSdkMethods";

class RewardsSdk implements SdkRegisteredModuleInterface {
    public readonly events: RewardsSdkEvents;

    public readonly methods: RewardsSdkMethods;

    constructor(
        private readonly _collector: SdkMethodsCollector,
        private readonly productsQuery: ProductsQuery
    ) {
        this.events = new RewardsSdkEvents();
        this.methods = new RewardsSdkMethods(
            this._collector,
            this.productsQuery
        );
    }

    public register(sdk: Sdk & { rewards?: RewardsSdk }) {
        sdk.rewards = this;
    }
}

export default RewardsSdk;
